/**
 * 生成标准化的下载文件名
 * 格式：YYYYMMDDHHmmss{id}
 * 例如：20251218140125abcd
 * 
 * @param {string} id - 资源ID，如果未提供则使用随机字符串
 * @returns {string} 格式化后的文件名（不含扩展名）
 */
export const generateDownloadFilename = (id) => {
  const now = new Date();
  
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;
  const resourceId = id || Math.random().toString(36).substring(2, 8);
  
  return `${timestamp}${resourceId}`;
};

/**
 * 触发文件下载
 * @param {string} url - 文件URL
 * @param {string} filename - 文件名（不含扩展名）
 * @param {string} extension - 文件扩展名（例如 'png', 'mp4'），默认为 'png'
 */
export const downloadFile = (url, filename, extension = 'png') => {
  if (!url) return;
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
